module.exports = __webpack_public_path__ + "static/media/Fog.b2082d48.jpg";